import "@/index.css";
import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";

import Nav from "@/components/vss/Nav";
import Hero from "@/components/vss/Hero";
import Stats from "@/components/vss/Stats";
import Ecosystem from "@/components/vss/Ecosystem";
import Services from "@/components/vss/Services";
import Industries from "@/components/vss/Industries";
import Technology from "@/components/vss/Technology";
import WhyVSS from "@/components/vss/WhyVSS";
import Process from "@/components/vss/Process";
import Marquee from "@/components/vss/Marquee";
import About from "@/components/vss/About";
import TalentNetwork from "@/components/vss/TalentNetwork";
import Contact from "@/components/vss/Contact";
import Footer from "@/components/vss/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.1,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="relative min-h-screen bg-white text-slate-900" data-testid="vss-app">
      <div className="vss-grain" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <Stats />
        <Ecosystem />
        <Services />
        <Industries />
        <Technology />
        <WhyVSS />
        <Process />
        <Marquee />
        <About />
        <TalentNetwork />
        <Contact />
      </main>
      <Footer />
      <Toaster theme="light" position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
